import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import PageLoader from '../../../../../../component/PageLoader';

export default function DeliveryChallansGeneral({ setForm, form, error, setError, loader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	return (
		<div>
			{loader.isGetData && loader.isLoader ? (
				<PageLoader />
			) : (
				<div className="p-4">
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">Terms & Conditions</div>
						<div className="col-8 col-lg-6 my-2">
							<InputField
								type="text"
								value={form?.terms_and_conditions}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('terms_and_conditions', value)}
								error={error?.terms_and_conditions}
								required
								autoComplete="new-password"
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">Customer Notes</div>
						<div className="col-8 col-lg-6 my-2">
							<InputField
								type="text"
								value={form?.customer_notes}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('customer_notes', value)}
								error={error?.customer_notes}
								required
								autoComplete="new-customer-notes"
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
